import React from 'react';
import { Box, Stack, StackProps, Typography } from '@mui/material';
import ContentDescription from '@/components/MenuDrawer/MyMenuDrawer/@components/ContentDescription';
import Radio from '@/components/@IntranetLibrary/Radio';
import { styled } from '@mui/material/styles';

export const ItemWrapper = styled(Box)`
  width: 100%;
  display: flex;
`;

export const ItemTitle = styled(Box)`
  flex: 1;
  color: var(--dk-text, #000);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;

export const ItemContent = styled(Box)`
  flex: none;
`;

export const Section = styled(Stack)`
  gap: 12px;
`;

export const SectionTitle = styled(Typography)`
  color: var(--dk-text-secondary, #888d96);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const SectionContent = styled(
  ({ children, sx, ...props }: StackProps) => (
    <ContentDescription
      {...props}
      sx={{
        ...sx,
        padding: '16px 12px',
      }}
      hasVerticalMargin={false}
    >
      {children}
    </ContentDescription>
  ),
)(() => ({
  gap: '24px',
}));

export const RadioSelectWrapper = styled(
  ({ children, ...props }: StackProps) => <Stack {...props}>{children}</Stack>,
)(() => ({
  gap: '16px',
}));

export const RadioSelect = styled(Radio)`
  gap: 16px;

  & .MuiFormControlLabel-root {
    padding: 0;
    margin: 0;
    gap: 12px;
  }
  & .MuiTypography-root {
    color: var(--dk-text, #000);
    font-size: 14px;

    &.Mui-disabled {
      color: var(--dk-text, #000) !important;
    }
  }
`;
